// Drop-in replacement for localStorage.clear() that preserves LaunchDarkly's
// persisted anonymous context ('ld:'-prefixed keys). Deleting those keys mints
// a new LD context — and a new billable MAU — on every logout/anonymous visit.
// Everything else is removed, identical to localStorage.clear().
export const clearStorageExceptLD = () => {
  // Iterate backwards: localStorage.key(i) reindexes live on removal.
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    if (key && !key.startsWith('ld:')) {
      localStorage.removeItem(key)
    }
  }
}
